__turbopack_context__.v({
  "bannerContent": "wSLvGG_bannerContent",
  "blurredGradient": "wSLvGG_blurredGradient",
  "descriptionText": "wSLvGG_descriptionText",
  "logoWrapper": "wSLvGG_logoWrapper",
  "poweredByText": "wSLvGG_poweredByText",
  "vioBannerContainer": "wSLvGG_vioBannerContainer",
  "vioLogo": "wSLvGG_vioLogo",
});
